/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ spaceNames: NonNullable<unknown> }} Spaces_Linked_Spaces_Hint_TeamInputs */



/**
* | output |
* | --- |
* | "All team members will also gain read access to the linked spaces: {spaceNames}" |
*
* @param {Spaces_Linked_Spaces_Hint_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_linked_spaces_hint_team = /** @type {((inputs: Spaces_Linked_Spaces_Hint_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Linked_Spaces_Hint_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Alle Teammitglieder erhalten auch Lesezugriff auf die verknüpften Spaces: ${i?.spaceNames}`)
	return /** @type {LocalizedString} */ (`All team members will also gain read access to the linked spaces: ${i?.spaceNames}`)
});